<template>
	<div>
		<Gallery110UserLoanPrintHtml :userLoanId="userLoanId" :area="area" @ready="$emit('ready')" v-if="customerCode == 305" />
		<DefaultUserLoanPrintHtml :userLoanId="userLoanId" :area="area" @ready="$emit('ready')" v-else />
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { sumBy } from 'lodash'

	export default {
		name: 'DefaultUserLoanPrint',
		components: {
			DefaultUserLoanPrintHtml: () => import('./UserLoanPrints/DefaultUserLoanPrintHtml'),
			Gallery110UserLoanPrintHtml: () => import('./UserLoanPrints/Gallery110UserLoanPrintHtml'),
		},
		props: {
			userLoanId: {
				type: String,
			},
			area: {
				type: String,
				default: 'admin'
			}
		},
		data: () => ({

		}),
		mounted() {
		},
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			customerCode() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer) { return `${user.userData.customer.code}` }
				return ''
			},
		},
		methods: {

		}
	}
</script>
<style scoped></style>